<div class="modal-header">
  <span class="title">{{'mkb.card3dsecure.modal.modify.title' | resolve}}</span>
  <mat-icon class="icon-close" (click)="close()"></mat-icon>
</div>
<div class="modal-wrapper" [ngClass]="{'ie11': isIE11}">
  <form [formGroup]="modifyModalFormGroup" autocomplete="off">
    <mat-form-field class="w-200 pass-icon">
      <div class="filed-title">{{'mkb.card3dsecure.modal.modify.secure.code.title' | resolve}}</div>
      <pass-visibilty-icon matSuffix #toggle></pass-visibilty-icon>
      <input matInput
             digitOnly
             isInteger = "true"
             sessionReviveInput
             maxlength="4"
             [type]="toggle.type"
             formControlName="secureCode">
      <mat-error *ngIf="modifyModalFormGroup?.get('secureCode').hasError('required')">
        {{'mkb.card3dsecure.common.required.error' | resolve}}
      </mat-error>
      <mat-error *ngIf="modifyModalFormGroup?.get('secureCode').hasError('maxlength')">
        {{'mkb.card3dsecure.modal.modify.secure.code.maxlength.error' | resolve}}
      </mat-error>
      <mat-error *ngIf="modifyModalFormGroup?.get('secureCode').hasError('minlength')">
        {{'mkb.card3dsecure.modal.modify.secure.code.minlength.error' | resolve}}
      </mat-error>
      <mat-error *ngIf="modifyModalFormGroup?.get('secureCode').hasError('sameAsPresent')">
        {{'mkb.card3dsecure.modal.modify.secure.code.same.as.old.error' | resolve}}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="w-200 pass-icon">
      <div class="filed-title">{{'mkb.card3dsecure.modal.modify.secure.code2.title' | resolve}}</div>
      <pass-visibilty-icon matSuffix #toggle2></pass-visibilty-icon>
      <input matInput
             digitOnly
             isInteger = "true"
             sessionReviveInput
             maxlength="4"
             [type]="toggle2.type"
             formControlName="secureCode2">
      <mat-error *ngIf="modifyModalFormGroup?.get('secureCode2').hasError('required')">
        {{'mkb.card3dsecure.common.required.error' | resolve}}
      </mat-error>
      <mat-error *ngIf="modifyModalFormGroup?.get('secureCode2').hasError('maxlength')">
        {{'mkb.card3dsecure.modal.modify.secure.code.maxlength.error' | resolve}}
      </mat-error>
      <mat-error *ngIf="modifyModalFormGroup?.get('secureCode2').hasError('notSameCodes')">
        {{'mkb.card3dsecure.modal.modify.secure.code.not.the.same.error' | resolve}}
      </mat-error>
    </mat-form-field>
  </form>
  <div class="button-wrapper">
    <button mat-flat-button sessionReviveClick color="primary" [disabled]="modifyModalFormGroup.invalid" (click)="doModify()">
      {{'mkb.card3dsecure.modal.modify.modify.button.title' | resolve}}
    </button>
    <button mat-flat-button sessionReviveClick color="basic" (click)="close()">
      {{'mkb.card3dsecure.modal.modify.cancel.button.title' | resolve}}
    </button>
  </div>
</div>
